import { Brightness1 } from "@mui/icons-material";
import { connect, ConnectedProps } from "react-redux";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { IStore } from "../../../store/IStore";
import { CardDesignDto } from "../../../store/models/carddesign/CardDesignDto";
import { KNISTR_GREEN, KNISTR_RED } from "../../atoms/ImsMaterialTheme";
import { ImsHeadCell, ImsTable, ImsTableRow } from "../../atoms/ImsTable";
import CardDesignTableMenu from "./CardDesignTableMenu";
import { useTranslation } from "react-i18next";

const CardDesignTable = (props: ThunkProps) => {
  const { cardDesigns } = props;
  const { t } = useTranslation();
  const headCells: ImsHeadCell<CardDesignDto>[] = [
    { val: (val) => val.cardDesignNumber, node: t("setup.headlineId") },
    { val: (val) => val.name, node: t("setup.headlineDesignation") },
    {
      val: (val) => val.defaultCardDesign,
      node: t("setup.headlineStandardTouchpoint"),
    },
    {
      val: (val) => Boolean(val.templateName),
      node: t("setup.headlineIdGeneration"),
    },
    {
      val: (val) => val.templateName,
      node: t("setup.headlineCardNumberPattern"),
    },
  ];
  const showBooleanLight = (isOn: boolean) => {
    return (
      <Brightness1
        style={{
          fill: isOn ? KNISTR_GREEN : KNISTR_RED,
          paddingTop: 4,
        }}
      />
    );
  };

  const rows: ImsTableRow<CardDesignDto>[] = cardDesigns?.map((row: CardDesignDto) => ({
    value: row,
    nodes: [
      row.externalCardDesignNumber,
      row.name,
      showBooleanLight(row.defaultCardDesign),
      showBooleanLight(Boolean(row.templateName)),
      row.templateName,

      <CardDesignTableMenu cardDesign={row} />,
    ],
  }));
  return rows.length ? (
    <ImsTable hasMenu={true} headCells={headCells} rows={rows} sortColumnIndex={1} sortDirection="desc" />
  ) : (
    <>{t("setup.noData")}</>
  );
};

const mapStateToProps = (state: IStore) => ({
  cardDesigns: state.identifications?.cardDesigns,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators({}, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);
type ThunkProps = ConnectedProps<typeof connector>;
export default connector(CardDesignTable);
